import { useNavigate, useParams } from "react-router";

import { useMainLayoutProvider } from "@providers/MainLayoutProvider/useMainLayoutProvider";

import { CurrentUser } from "@components/CurrentUser/CurrentUser";
import { ClientMenu, OrganizationMenu } from "@components/Menus";

import { AffireLogo } from "@design-system/AffireLogo/AffireLogo";
import { Box } from "@design-system/Box/Box";
import { Clickable } from "@design-system/Clickable/Clickable";
import { IconButton } from "@design-system/IconButton/IconButton";

import { routes } from "@pages/routes";

import { useBreakpoint } from "@utils/hooks/useBreakpoint";

import classes from "./MainNavigation.module.css";

export const MainNavigation = () => {
  const navigate = useNavigate();
  const { isSmallerThan } = useBreakpoint();
  const { toggleMobileNavigation, closeMobileNavigation } =
    useMainLayoutProvider();

  const { clientId } = useParams();

  const handleLogoClick = () => {
    closeMobileNavigation();
    navigate(routes.portal.dashboard.$path(), { viewTransition: true });
  };

  const handleProfileClick = () => {
    closeMobileNavigation();
    navigate(routes.portal.profile.$path(), { viewTransition: true });
  };

  return (
    <div className={classes.container}>
      <header className={classes.header}>
        <Box
          padding="4px 21px"
          justify="space-between"
          align="center"
          gap={12}
          stretch
        >
          <Clickable onClick={handleLogoClick} outline="md">
            <AffireLogo />
          </Clickable>

          {isSmallerThan.laptop && (
            <IconButton icon="faArrowLeft" onClick={toggleMobileNavigation} />
          )}
        </Box>
      </header>

      {clientId ? <ClientMenu /> : <OrganizationMenu />}

      <footer className={classes.footer}>
        <Box direction="column" gap={12} fullStretch>
          <Clickable onClick={handleProfileClick} outline="sm" stretch>
            <CurrentUser />
          </Clickable>
        </Box>
      </footer>
    </div>
  );
};
